const requireModule = require.context('./', true, /\.js$/)
const modules = {}

requireModule.keys().forEach(fileName => {
    if (fileName.split('/').includes('modules')) {
        if (!fileName.endsWith('index.js')) return
        const path = fileName.replace(/(\.\/|\.js)/g, '')
        const [moduleName] = path.split('/')
        modules[moduleName]['modules'] = requireModule(fileName).default
    }
    else {
        if (fileName.endsWith('index.js')) return
        const path = fileName.replace(/(\.\/|\.js)/g, '')
        const [moduleName, imported] = path.split('/')

        if (!modules[moduleName]) {
            modules[moduleName] = {
                namespaced: true
            }
        }
        modules[moduleName][imported] = requireModule(fileName).default
    }
})

export default modules
